import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const apiUrl = environment.apiUrl + 'user/change_password';

@Injectable({
  providedIn: 'root',
})
export class ChangePasswordService {
  constructor(private http: HttpClient) {}

  changePassword(changePasswordInfo: any) {
    return this.http
      .post(apiUrl, changePasswordInfo)
      .pipe(
        map((res) => {
          //note: show success message
        })
      )
      .pipe(
        catchError((error) => {
          return this.handleError(error);
        })
      );
  }

  private handleError(errorRes: HttpErrorResponse) {
    let errorMessage = 'An unknown error occurred!';
    // if(errorRes['data'].new_password) {
    //   errorMessage = errorRes['data'].new_password[0];
    // } else if(errorRes.message) {
    //   errorMessage = errorRes.message;
    // }
    return throwError(errorMessage);
  }
}
